module.exports = __webpack_public_path__ + "static/media/logo.95ce6737.png";